import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { alpha, styled } from "@mui/material/styles";

import { paneIsCompact } from "work/_views/work-pane-layout";

const ReviewerLeaderMessageAside = styled("aside")(({ theme }) => ({
  alignSelf: "stretch",
  backgroundColor: alpha(theme.palette.info.main, 0.08),
  border: `1px solid ${alpha(theme.palette.info.main, 0.28)}`,
  borderRadius: theme.spacing(0.75),
  display: "grid",
  gap: theme.spacing(0.25),
  maxWidth: "22rem",
  minWidth: theme.spacing(24),
  padding: theme.spacing(0.75, 1),
  // Its text's width up to the cap, so it sits beside the buttons rather than taking a line (#5973).
  width: "auto",
  [paneIsCompact(theme)]: {
    maxWidth: "none",
    minWidth: 0,
  },
}));
const ReviewerLeaderMessageBody = styled(Typography)(() => ({
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));
const ReviewerLeaderMessageTooltipTitle = styled("span")(() => ({
  whiteSpace: "pre-wrap",
}));

/**
 * The message a team leader wrote when they asked this reviewer to review, drawn beside the
 * reviewer's Complete Review action. Draft and active pages alike (#7075). Draws nothing when the
 * message is empty or only whitespace.
 */
export default function ReviewerLeaderMessage({ message }: Readonly<{ message: string | null | undefined }>) {
  const text = message?.trim();
  if (!text) return null;

  return (
    <ReviewerLeaderMessageAside aria-label="Reviewer custom message">
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700 }}>
        Message from team leader
      </Typography>
      <Tooltip
        enterDelay={600}
        placement="bottom"
        title={<ReviewerLeaderMessageTooltipTitle>{text}</ReviewerLeaderMessageTooltipTitle>}
      >
        <ReviewerLeaderMessageBody variant="body2">{text}</ReviewerLeaderMessageBody>
      </Tooltip>
    </ReviewerLeaderMessageAside>
  );
}
